import { globalProvider } from 'Services/globalProvider';
import { DEFAULT_DOMAIN } from 'App/constants';

export const getFullUrl = function (url: string = ''): string {
  // check if url already includes host
  if (URL.canParse(url)) {
    return url;
  }
  const domain =
    globalProvider.windowProvider().location.hostname || DEFAULT_DOMAIN;

  return `https://${domain}${url}`;
};
